// extracted by mini-css-extract-plugin
export default {"labelClass":"CreditList_labelClass__PBQII"};